<template>
  <div v-if="dialogVisible" class="train_third_page">
    <div
      :title="title"
      visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="closeOnClickModal"
      destroy-on-close
      append-to-body
      @close="handleClose"
    >
      <div>
        <div class="layer-header-front">
          <div class="el-form-item">
            <label for="dataName" class="el-form-item__label">课件名称：</label>
            <div class="el-form-item__content">{{ dataName }}</div>
          </div>
        </div>
        <div class="page_item">
          <label class="el-form-item__label">培训资源名称：</label>
          <div class="el-form-item__content">{{ rowData.resourcesName }}</div>
        </div>
        <div class="page_item"><el-button @click="addShow" type="primary" v-if="forbidden">新增</el-button></div>
        <div class="page_item">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="编号" type="index" width="80">
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="fileName"
              label="文件名称"
            >
            </el-table-column>
            <el-table-column prop="typeName" label="视频类型">
            </el-table-column>

            <el-table-column prop="duration" label="时长"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="previewVideoShow(scope.row)"
                  >预览
                </el-button>

                <el-button
                  size="mini"
                  type="text"
                  v-if="forbidden"
                  @click="delDefinition(scope.$index)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <definition-video-add
          ref="videoAdd"
          @confirm="confirm"
        ></definition-video-add>
      </div>
      <div slot="footer" class="dialog-footer" style="padding: 20px 0 10px;">
        <el-button type="primary" v-if="forbidden" @click="submit()"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="dialogVisibleFn(false)">返 回</el-button>
      </div>
    </div>

    <preview-video ref="preview"></preview-video>
  </div>
</template>

<script>
import DefinitionVideoAdd from "./definitionVideoAdd";
import trainingVideo from "@/components/training/trainingVideo";
import previewVideo from "./previewVideo";
export default {
  components: { DefinitionVideoAdd, trainingVideo, previewVideo },
  name: "definitionVideo",
  props: {
    forbidden: {
      type: Boolean,
      default: false
    },
    dataName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "清晰度列表",
      dialogVisible: false,
      closeOnClickModal: false,

      tableData: [],
      rowDataClone: [], //存储
      index: undefined,
      rowData: undefined
    };
  },
  methods: {
    submit() {
      if (this.tableData.length < 1) {
        this.$message.error("请上传文件");
      } else {
        this.rowData.definitionVideo = this.tableData;
        this.$emit("videoConfirm", this.rowData, this.index);
        this.dialogVisibleFn(false);
      }
    },
    dialogVisibleFn(flag = false) {
      this.dialogVisible = flag;
      this.$emit("isShowDefinition", this.dialogVisible);
    },
    previewVideoShow(row) {
      this.$refs.preview.show(row.accessPath);
    },
    delDefinition(index) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.tableData.splice(index, 1);
          this.$message({
            message: "删除成功",
            type: "success"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    confirm(data) {
      this.tableData.push(data);
    },
    show(data, index, tableData) {
      this.index = index;
      this.rowData = data;
      this.tableData = tableData;
      this.rowDataClone = this.deepClone(data);
      // this.tableData=data;
      this.dialogVisibleFn(true);
    },
    addShow() {
      this.$refs.videoAdd.show();
    },

    //点击关闭
    handleClose() {
      this.$emit("closePop", this.rowDataClone, this.index);
    },

    deepClone(target) {
      // 定义一个变量
      let result;
      // 如果当前需要深拷贝的是一个对象的话
      if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
          result = []; // 将result赋值为一个数组，并且执行遍历
          for (let i in target) {
            // 递归克隆数组中的每一项
            result.push(this.deepClone(target[i]));
          }
          // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
          result = null;
          // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
          result = target;
        } else {
          // 否则是普通对象，直接for in循环，递归赋值对象的所有值
          result = {};
          for (let i in target) {
            result[i] = this.deepClone(target[i]);
          }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
      } else {
        result = target;
      }
      // 返回最终结果
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  border-top: 1px solid #dbdada;
  text-align: right;
  padding: 10px 20px !important;
}
.train_third_page{
  background: #fff;
  padding-bottom: 30px;
  .layer-header-front .el-form-item{
    margin: 0;
    padding-top: 13px;
    color: #fff;
  }
  .page_item{
    padding: 5px 15px;
  }
  .el-table::before{
    display: none;
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/definition/definitionVideo.vue